module.exports = __webpack_public_path__ + "img/bestWishBg.6f165125.jpg";